const OffsetDiv = (props) => {
    return <div style={{ width: props.width }}></div>;
};

export default OffsetDiv;
